import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import './HeroSection.css'
import MatrixBackground from '../effects/MatrixBackground'
import LearnMoreModal from './LearnMoreModal'
import flashMark from '../../assets/flash-mark.svg'

interface HeroSectionProps {
    onNavigateToOrder: () => void
}

export default function HeroSection({ onNavigateToOrder }: HeroSectionProps) {
    const { t } = useTranslation()
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <section className="hero-section">
            <MatrixBackground />

            <LearnMoreModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onExecute={() => {
                    setIsModalOpen(false)
                    onNavigateToOrder()
                }}
            />

            <div className="container">
                <div className="hero-content">
                    <motion.div
                        className="hero-text"
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                    >
                        <img className="hero-mark" src={flashMark} alt="TetherStream Protocol" />
                        <h1 className="hero-title">
                            <span className="title-brand ghost-glitch" data-text={t('hero.brand')}>{t('hero.brand')}</span>
                            <span className="title-tagline">{t('hero.tagline')}</span>
                        </h1>

                        <motion.div
                            className="hero-subtitle"
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <p>
                                {t('hero.description')}
                            </p>
                            <p className="hero-specs">
                                {t('hero.specs')}
                            </p>
                        </motion.div>

                        <motion.div
                            className="hero-cta"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, delay: 0.4 }}
                        >
                            <button className="btn btn-primary" onClick={onNavigateToOrder}>
                                {t('hero.executeOrder')}
                            </button>
                            <button className="btn" onClick={() => setIsModalOpen(true)}>
                                {t('hero.learnMore')}
                            </button>
                        </motion.div>
                    </motion.div>

                    <motion.div
                        className="hero-visual"
                        initial={{ opacity: 0, scale: 0.8, filter: "blur(10px)" }}
                        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        <div className="visual-container">
                            <div className="glow-orb"></div>
                            <div className="data-stream stream-1"></div>
                            <div className="data-stream stream-2"></div>
                            <div className="data-stream stream-3"></div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    )
}
